var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        staticClass: "cls-1",
        attrs: {
          id: "others-a",
          d:
            "M19.339798,11.6968393c.4236393-.4124193.5729771-1.0178947.3903675-1.5804262-.1826096-.5621443-.6592522-.964118-1.2442226-1.0492325l-3.3214092-.4824457c-.1284456-.0189571-.2394819-.0990429-.2967415-.2151079l-1.4856396-3.010354c-.2615347-.5300326-.7907934-.859272-1.3819542-.859272s-1.1208067.3292394-1.3823414.859272l-1.4860258,3.010354c-.0568724.116066-.1679087.1961508-.2955799.2151079l-3.3221836.4824457c-.5849705.0851145-1.0616131.4870882-1.2442226,1.0492325-.1826096.5625315-.0332723,1.1680069.3899803,1.580039l2.4041047,2.343751c.0924654.0901442.1346359.2197504.1129704.3470364l-.5675607,3.3086414c-.1002035.5826492.1346359,1.160656.6132131,1.5080795.4778032.3470364,1.0995278.3926888,1.6237569.1172256l2.970892-1.5622425c.114131-.0591927.2507019-.0607414.3656063,0l2.9716654,1.5626297c.2271013.1191616.4731607.1779671.7180586.1779671.3184071,0,.6348782-.0994301.9049244-.2955799.4785767-.3474236.7134171-.9254303.6132126-1.5080795l-.5675602-3.3086424c-.0216656-.127285.020504-.2572784.1129704-.3474226,0,0,2.4037189-2.3429775,2.4037189-2.3429766ZM16.1344528,13.2172976c-.3636723.3540001-.5292587.8643017-.4433708,1.3641577l.5675602,3.3086433c.0251484.1485634-.0344334.2955799-.1559143.383791-.1226425.0889835-.2812653.0998173-.4143543.0305634l-2.970892-1.5622425c-.2243938-.118-.4708395-.1771927-.7172852-.1771927s-.4928913.0591927-.7176723.1771927l-2.9701176,1.5618553c-.1342487.0700264-.2924852.0588074-.4151278-.0301762-.1214819-.0882092-.1810622-.2352257-.1559148-.383791l.5675607-3.3086424c.0858889-.5002422-.0800848-1.0105438-.4433703-1.3641577l-2.403718-2.343751c-.1079412-.104846-.1458559-.2588263-.0994296-.4019737.0460391-.1412134.1702294-.2460594.317246-.267725l3.3221841-.4824457c.5021772-.0731211.9362621-.3888197,1.1602688-.8434095l1.4856396-3.010354c.1338625-.269659.571043-.2704329.7045183,0l1.4852524,3.010354c.2243938.4545898.6584787.7702885,1.1614294.8434095l3.3214092.4824457c.1489506.0216656.2708206.1241903.3172455.267725.0464268.1431475.0085106.2971277-.0998173.4023609,0,0-2.4033318,2.3433638-2.4033298,2.3433628Z"
        }
      })
    ]),
    _vm._v(" "),
    _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
      _c("rect", {
        staticStyle: { "mix-blend-mode": "color-burn" },
        attrs: {
          width: "24",
          height: "24",
          fill: "#E3E3E3",
          "fill-opacity": ".01"
        }
      }),
      _vm._v(" "),
      _c("use", {
        attrs: {
          fill: _vm.currentColor,
          opacity: _vm.opacity,
          "fill-rule": "nonzero",
          "xlink:href": "#others-a"
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }